import api from "@/api/apiConfig"
import {
  Post,
  Get
} from './base/baseAjax'
let getUnderStaff = (param) => {
  return Post({
    url: api.workTable.getUnderStaff,
    bodyParam: param
  })
}
let getcheckin = (param) => {
  return Get({
    url: api.workTable.getcheckin,
    PathParam: param
  })
}
let getcheckininfo = (param) => {
  return Post({
    url: api.workTable.getcheckininfo,
    bodyParam: param
  })
}
let getApprovallist = (param) => {
  return Post({
    url: api.workTable.getApprovallist,
    bodyParam: param
  })
}

export default {
  getUnderStaff,
  getcheckin,
  getcheckininfo,
  getApprovallist
}



// WEBPACK FOOTER //
// ./src/services/workTable.js